// // src/routesConfig.ts
// import React, { lazy, Suspense } from 'react';
// import { Route, Routes } from 'react-router-dom';
// import { NavBarMenuItem } from '../models/types/NavBarMenu';
// import Home from '../pages/home/Home';

// export const generateRoutesForNavBarMenu = (items: NavBarMenuItem[]): (JSX.Element | null)[] => {
//     // Sort items by the 'order' property before rendering
//     const sortedItems = [...items].sort((a, b) => a.order - b.order);

//     return sortedItems.flatMap((item, index) => {
//         if (item.isRoute) {

//             const LazyComponent = lazy(() => import(`../${item.componentPath}`));
//             return (
//                 <div key={index}>
//                     <Routes >
//                         <Route
//                             key={item.uniqueId}
//                             path={item.url}
//                             element={
//                                 <Suspense fallback={<div>Loading Services...</div>}>
//                                     <LazyComponent item={item} />
//                                 </Suspense>
//                             }
//                         />
//                     </Routes>
//                     {item.children ? generateRoutesForNavBarMenu(item.children) : null}
//                 </div>
//             );
//         }
//         return item.children ? generateRoutesForNavBarMenu(item.children) : null;
//     }).filter(Boolean); // Filter out any null values
// };


import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import { NavBarMenuItem } from '../models/types/NavBarMenu';

export const generateRoutesForNavBarMenu = (items: NavBarMenuItem[]): JSX.Element[] => {
    // Sort items by the 'order' property before rendering
    const sortedItems = [...items].sort((a, b) => a.order - b.order);

    return sortedItems.flatMap((item) => {
        const routes: JSX.Element[] = [];
        if (item.isRoute) {
            const LazyComponent = lazy(() => import(`../${item.componentPath}`));
            routes.push(
                <Route
                    key={item.uniqueId}
                    path={item.url}
                    element={<LazyComponent item={item} />}
                />
            );
        }
        if (item.children) {
            routes.push(...generateRoutesForNavBarMenu(item.children));
        }
        return routes;
    });
};